import React from 'react';
import { PropTypes } from 'prop-types';

const DirectChip = ({
  isDirect
}) => (
  <React.Fragment>
    { isDirect === false && <span className="chip chip--indirect">INDIRECT</span> }
  </React.Fragment>
);

DirectChip.propTypes = {
  isDirect: PropTypes.bool,
};

DirectChip.defaultProps = {
  isDirect: null
};

export default DirectChip;
